import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "@/lib/analytics";

/**
 * Automatically track page_view on every route change.
 * Mount once at the top of the app (inside BrowserRouter).
 */
export default function AnalyticsTracker() {
  const location = useLocation();
  useEffect(() => {
    trackPageView();
  }, [location.pathname]);
  return null;
}
